import { useLoadingState } from "@src/contexts/LoadingProvider";
import View from "@components/View";
import { LoadingType } from "@playroomkit/pr-wars/utils";
import { GameLoadingScreen } from "@components/LoadingScreens/GameLoadingScreen";
import { MainMenuLoadingScreen } from "@components/LoadingScreens/MainMenuLoadingScreen";

const LoadingContent = () => {
    const { loadingMessage, showLoadingBar, percentage, type } = useLoadingState();

    const renderLoadingUI = () => {
        return (
          <View
            className={`w-full h-full absolute top-0 left-0 right-0 bottom-0 ${
              showLoadingBar ? "opacity-100 z-[9999999]" : "opacity-0 -z-[9999999]"
            }`}
          >
            <GameLoadingScreen
              isVisible={type === LoadingType.Game}
              percentage={percentage}
              showLoadingBar={showLoadingBar}
            />
            <MainMenuLoadingScreen
              isVisible={type === LoadingType.MainMenu}
              message={loadingMessage}
              percentage={percentage}
            />
          </View>
        );
      };

  return renderLoadingUI();
};

export default LoadingContent;